<kodit-info-container>
  <div body-full>
    <div class="kodit-card-tab">
      <kodit-opsta-pravila-arhivska></kodit-opsta-pravila-arhivska>
    </div>
    <div class="kodit-card-tab p-mt-5">
      <kodit-dokumentacija-arhivske-podesavanja></kodit-dokumentacija-arhivske-podesavanja>
    </div>
    <div class="p-mt-5 kodit-card-tab">
      <p-tabView>
        <p-tabPanel header="Fizičke lokacije">
          <div class="p-mt-4">
            <kodit-fizicke-lokacije-tree></kodit-fizicke-lokacije-tree>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Skladišne jedinice">
          <div class="p-mt-4">
            <kodit-skladisne-jedinice-table></kodit-skladisne-jedinice-table>
          </div>
        </p-tabPanel>
         <p-tabPanel header="Pravila brojeva delovodnih dokumenata">
          <div class="p-mt-3">
            <kodit-delovodni-dokument-pravila-za-broj></kodit-delovodni-dokument-pravila-za-broj>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Kategorije dokumentarnog materijala">
          <div class="p-mt-4">
            <kodit-kategorije-materijala-table></kodit-kategorije-materijala-table>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</kodit-info-container>
